import { QueryClient } from "@tanstack/react-query"
import { getFullSettingsQueryOptions } from "./index"
import { tryCatch } from "@/lib/utils/try-catch"

export const settingsLoader = (queryClient: QueryClient) => async () => {
  const [settings, settingsError] = await tryCatch(
    queryClient.ensureQueryData(getFullSettingsQueryOptions)
  )
  if (settingsError) {
    return null
  }
  return settings
}
